import React from 'react'
import { ButtonAnchor } from '@the-game/components'
import { Share } from '@the-game/components/icons'
import { GameName, SportName } from '@the-game/api-interfaces'

interface ShareCompetitionLinkProps {
    competitionName: string
    competitionUrl: string
    sport: SportName
    game: GameName
    variant?: 'ghost'
    event?: () => void
    disabled?: boolean
    lockoutRound?: number
}

export function ShareCompetitionLink({
    competitionName,
    competitionUrl,
    sport,
    game,
    children,
    variant,
    event = () => undefined,
    disabled,
    lockoutRound,
}: ShareCompetitionLinkProps &
    React.HTMLProps<HTMLAnchorElement>): JSX.Element {
    const round = lockoutRound || 0
    const roundDeadline =
        round > 0 && typeof lockoutRound === 'number'
            ? `%0D%0A
            %0D%0A
    This competition has a join deadline, make sure you join before round ${round} ends to avoid missing out!
    %0D%0A
    %0D%0A`
            : `%0D%0A
        %0D%0A`
    const utmTags =
        '?utm_source=External&utm_medium=EDM&utm_campaign=TheGameInvite&utm_term=joincomp&utm_content=hyperlink'
    const subject = `Join my ${sport} ${game} Competition in The Game!`
    // Line breaks in the body of a message MUST be encoded with "%0D%0A"
    const body = `Come and join my ${sport} ${game} competition ${competitionName} in The Game.
        %0D%0A
        %0D%0A
    You can join in the fun by clicking on the following link: ${encodeURIComponent(
        competitionUrl + utmTags,
    )}
    ${roundDeadline}
    You will need to login or register, if you haven't already registered to play in The Game.
    `
    return (
        <ButtonAnchor
            href={
                disabled ? undefined : `mailto:?subject=${subject}&body=${body}`
            }
            variant={variant}
            onClick={disabled ? undefined : event}
            disabled={disabled}
        >
            <Share size="md" />
            {children}
        </ButtonAnchor>
    )
}
